import React, { createContext, useState } from 'react';

export const SettingsContext = createContext(null);

export const SettingsContextProvider = ({ children }) => {
  const [navDrawerOpen, setNavDrawer] = useState(false);
  const [isDarkMode, setMode] = useState(false);

  return (
    <SettingsContext.Provider
      value={{
        navDrawerOpen,
        setNavDrawer,
        isDarkMode,
        setMode,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
